import { render } from "./iconChevronCircleBottom.vue?vue&type=template&id=36ca97bc"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__